<app-spinner-manual></app-spinner-manual>
<router-outlet></router-outlet>

